import React from 'react'
import { useIntl } from 'react-intl'
import '../style'
import { StatisticsContainer, StatsDesc, StatsText } from '../style'

const LandingStatistics = () => {
    const { formatMessage, locale } = useIntl()

    return (
        <StatisticsContainer>
            <div>
                <StatsText>5000+</StatsText>
                <StatsDesc>{formatMessage({ id: 'firstStatsText1' })}</StatsDesc>
                <StatsDesc>
                    <span>{formatMessage({ id: 'firstStatsText2' })}</span>{' '}
                    {formatMessage({ id: 'firstStatsText3' })}
                </StatsDesc>
            </div>

            <div>
                <StatsText>408</StatsText>
                <StatsDesc>{formatMessage({ id: 'secondStatsText1' })}</StatsDesc>
                <StatsDesc>
                    <span>{formatMessage({ id: 'secondStatsText2' })}</span>
                </StatsDesc>
            </div>

            <div>
                <StatsText>2500+</StatsText>
                <StatsDesc>{formatMessage({ id: 'thirdStatsText1' })}</StatsDesc>
                <StatsDesc>
                    <span>{formatMessage({ id: 'thirdStatsText2' })}</span>{' '}
                    {locale === 'kz' && formatMessage({ id: 'thirdStatsText3' })}
                </StatsDesc>
            </div>
        </StatisticsContainer>
    )
}

export default LandingStatistics
